import { PropsWithChildren, memo } from 'react';
import { AppContextProvider, TOAST_INITIAL_STATE } from './AppContext';
import { FeatureToggleProvider } from './featureToggleContext';
import { WebEngageProvider } from './webengageContext';
import { ProfileProvider } from './profileContext';
import { ProductProvider } from './productContext';
import { PaymentProvider } from './paymentContext';
import { ServiceRequestProvider } from './serviceRequestContext';
import { ServiceProvider } from './serviceContext';
import { StatusTrackingProvider } from './statusTrackingContext';
import { AppProps } from 'next/app';
import { CustomAppProps } from '@/types';
import type { FeaturesType } from '@/actions/fetchFeatures';
import { EcomProductProvider } from './ecomProductContext';

interface ProvidersProps {
  featureFlags: FeaturesType;
}

const Providers = ({
  children,
  pageProps,
  featureFlags,
  config,
  profile,
}: PropsWithChildren<AppProps & CustomAppProps & ProvidersProps>) => {
  return (
    <AppContextProvider
      value={{
        ...config,
        search: false,
        aqiBar: false,
        login: { open: false },
        hamburger: false,
        toast: TOAST_INITIAL_STATE,
        promoOffer: { open: false },
        location: null,
      }}
    >
      <FeatureToggleProvider featureFlags={featureFlags}>
        <WebEngageProvider>
          <ProfileProvider value={{ ...(profile ?? {}) }}>
            <EcomProductProvider>
              <ProductProvider
                value={{
                  selectedProduct: pageProps?.selectedDevice,
                  amcPlans: {
                    mobileData: pageProps?.amcData?.mobileData,
                    webData: pageProps?.amcData?.webData,
                  },
                }}
              >
                <PaymentProvider>
                  <ServiceRequestProvider>
                    <ServiceProvider>
                      <StatusTrackingProvider>{children}</StatusTrackingProvider>
                    </ServiceProvider>
                  </ServiceRequestProvider>
                </PaymentProvider>
              </ProductProvider>
            </EcomProductProvider>
          </ProfileProvider>
        </WebEngageProvider>
      </FeatureToggleProvider>
    </AppContextProvider>
  );
};

export default memo(Providers);
